import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getArtPrestadores, getArts } from "../../../../../actions/arts";
import {
  getTrasladosSituacionActual,
  getTrasladosSituacionPorPeriodo,
} from "../../../../../actions/traslados";
import { getDefaultPeriodoFechas } from "./reportesChartUtils";
import ReportesTraslados from "./reportesTraslados";

const ReportesTrasladosContainer = () => {
  const dispatch = useDispatch();
  const roles = useSelector((state) => state.auth.roles);
  const situacionActual = useSelector((state) => state.traslados.situacionActual);
  const situacionPeriodo = useSelector((state) => state.traslados.situacionPeriodo);
  const arts = useSelector((state) => state.arts.list);
  const artsLoading = useSelector((state) => state.arts.isFetching);
  const artPrestadores = useSelector((state) => state.arts.artPrestadores);

  const isBackofficeRole = roles?.tipo === "Soporte" || roles?.tipo === "Administrador";
  const [selectedArtId, setSelectedArtId] = useState(null);
  const periodDefaults = useMemo(() => getDefaultPeriodoFechas(), []);
  const [periodValues, setPeriodValues] = useState(periodDefaults);
  const artUserArtId = artPrestadores.data?.[0]?.arts?.[0]?.id;
  const idArt = isBackofficeRole ? selectedArtId : artUserArtId;

  useEffect(() => {
    if (isBackofficeRole && arts.length === 0 && !artsLoading) {
      dispatch(getArts());
    }
    if (!isBackofficeRole && artPrestadores.data.length === 0 && !artPrestadores.isFetching) {
      dispatch(getArtPrestadores());
    }
  }, [
    dispatch,
    isBackofficeRole,
    arts.length,
    artsLoading,
    artPrestadores.data.length,
    artPrestadores.isFetching,
  ]);

  const refreshActual = useCallback(() => {
    if (!idArt) {
      return;
    }
    dispatch(getTrasladosSituacionActual(idArt));
  }, [dispatch, idArt]);

  const refreshPeriodo = useCallback(() => {
    if (!idArt) {
      return;
    }
    dispatch(
      getTrasladosSituacionPorPeriodo(
        periodValues.fechaDesde,
        periodValues.fechaHasta,
        idArt,
      ),
    );
  }, [dispatch, idArt, periodValues]);

  useEffect(() => {
    refreshActual();
  }, [refreshActual]);

  useEffect(() => {
    refreshPeriodo();
  }, [refreshPeriodo]);

  return (
    <ReportesTraslados
      situacionActual={situacionActual}
      situacionPeriodo={situacionPeriodo}
      periodInitialValues={periodValues}
      onPeriodChange={setPeriodValues}
      onRefreshActual={refreshActual}
      onRefreshPeriodo={refreshPeriodo}
      isBackofficeRole={isBackofficeRole}
      arts={arts}
      artsLoading={artsLoading}
      selectedArtId={selectedArtId}
      onArtChange={setSelectedArtId}
    />
  );
};

export default ReportesTrasladosContainer;
